/**
 * QorbomBrand.jsx — single source of truth for the QorBOM™ wordmark.
 *
 * Always renders `QorBOM` followed by the trademark ™ symbol as a
 * properly-styled superscript. Every QorBOM mention on the platform
 * MUST use this component (never the bare string "QorBOM" in JSX
 * content) so trademark protection is consistent across every surface.
 *
 * Props:
 *   • `as`          — element to render as (default: 'span')
 *   • `className`   — passthrough class
 *   • `tmClassName` — class for the ™ glyph (default sizes it down)
 */
import React from "react";

export default function QorbomBrand({
  as: Tag = "span",
  className = "",
  tmClassName = "ml-0.5 align-super text-[0.5em] font-medium opacity-80",
  children,
}) {
  return (
    <Tag className={className}>
      {children || "QorBOM"}
      <span className={tmClassName} aria-label="trademark">™</span>
    </Tag>
  );
}

// Convenience: brand with a fixed tagline suffix.
export function QorbomBrandLong({ className = "" }) {
  return (
    <span className={className}>
      <QorbomBrand /> Platform
    </span>
  );
}
